<template>
  <div id="key-board">
    <div style="flex-direction: row;display: flex;font-size: 25px">
      内容:
      <div
        v-for="(item,index) in this.cValue"
        :style="{width:'37px',margin:'0px 3px',color:'hsl(296deg 47% 66%)',display:'grid',placeItems:'center',
        border:'2px #93c6f0 solid',backgroundColor:cIndex==index?'rgb(250 213 178)':'#b2ebfa'}"
        class="ybInput"
        @click="changeIndex(`${index}`)"
        :key="index">
        {{ item }}
      </div>
    </div>
    <div v-show="type >= 1" class="key-board">
      <ul class="clearfix ul_keybord">
        <li
          @click="input(item, index)"
          v-for="(item, index) in keyList2" :key="item"
          :class="{
            ikey:true,
            ['ikey' + index]: true,
            ['ikeycode' + item]: true,
            li_num: index < 10,
            li_zm: index > 9,
            li_w: index > 28,
            disabled:(item !=='删除' && ((type === 1 && index < 10) || type === 3))||
            type===5&&!available.includes(item)||car_type==1&&item=='插入内容'
          }"
        >
          <span>{{item}}</span>
        </li>
      </ul>
      <ul class="clearfix ul_keybord" v-show="type !== 0&&car_type==1">
        <li
          @click="input2(item, index)"
          v-for="(item, index) in keyList3" :key="item"
          :class="{
            disabled: cValue.length < 6 || (type === 1 && index < 6) || type === 3
          }">
          <span>{{item}}</span>
        </li>
      </ul>
    </div>
    <div v-show="type === 0" class="key-board">
      <ul class="clearfix ul_pro">
        <li
          @click="chooseProvince(item);"
          v-for="item in keyList1" :key="item">
          <span>{{item}}</span>
        </li>
        <!-- <li class="li_close" onclick="closePro();">
          <span>关闭</span>
        </li> -->
        <!-- <li class="li_clean" onclick="cleanPro();">
          <span>清空</span>
        </li> -->
      </ul>
    </div>
  </div>
</template>
<script>
import _ from 'lodash'
export default {
  name: 'key-board',
  props: {
    value: {
      type: Array,
      default: () => []
    },
    car_type:1  //1:车牌号  2:身份证
  },
  data () {
    return {
      cIndex:0,
      cValue: this.value,
      //身份证
      available:['0', '1', '2', '3', '4', '5', '6', '7', '8', '9','插入内容','X','删除'],//身份证录入可用按钮
      //车牌号
      keyList1: ['京', '沪', '浙', '苏', '粤', '鲁', '晋', '冀', '豫', '川', '渝', '辽', '吉', '黑', '皖', '鄂', '津', '贵', '云', '桂', '琼', '青', '新', '藏', '蒙', '宁', '甘', '陕', '闽', '赣', '湘'],
      keyList2: ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', 'Q', 'W', 'E', 'R', 'T', 'Y', 'U', 'I', 'O', 'P', 'A', 'S', 'D', 'F', 'G', 'H', 'J', 'K', 'L','插入内容','Z', 'X', 'C', 'V', 'B', 'N', 'M', '删除'],
      keyList3: ['港', '澳', '学', '警', '领', '使'],
    }
  },
  computed: {
    //0 显示车号页  大于0不显示车号页
    //1 全局可用
    //2 除港澳台全局可用
    //3 全局禁选
    //5 用于身份证录入:除了数字和X禁选
    type () {
      let changeIndex=Number(this.cIndex)
      let result = 0
      if(this.car_type==2){
        if(this.value.length>17&&changeIndex>17){
          return 3
        }
        return 5
      }
      if(this.car_type==1){
        if(this.value.length>7&&changeIndex>7){
          return 3
        }else {
          switch (changeIndex) {
            case 0:
              result= 0
              break
            case 1:
              if(!this.value){  //应对删除所有值时的逻辑异常
                result= 0
              }else{
                result= 1
              }
              break
            case 7:
              result= 2
              break
            case 8:
              result= 2
              break
            default:
              result= 2
              break
          }
        }
      }
      return result
    }
  },
  methods: {
    changeIndex(index){
      this.cIndex=index
    },
    chooseProvince (val) {
      this.cValue.splice(0, 1, val)
      this.cIndex=Number(this.cIndex)+1
    },
    input (val, index) {
      switch (val) {
        case '删除'://计算删除后选中节点
          if(this.cIndex>=this.cValue.length){
            this.cIndex=Number(this.cIndex)-1
            this.cValue.pop()
          }else{
            this.cValue.splice(this.cIndex,1)
          }
          //删除最后一个
          if(this.cIndex!==0){
            this.cIndex=Number(this.cIndex)
          }
          break;
        case '插入内容':
          if ((this.type === 1 && index < 10) || this.type === 3||this.car_type==1) return
          this.cValue.splice(Number(this.cIndex)+1,'0','')
          this.cIndex=Number(this.cIndex)+1
          break;
        default:
          if ((this.type === 1 && index < 10) || this.type === 3||this.type===5&&!this.available.includes(val)) return
          //判断是中间节点修改,还是末尾节点新增
          if(this.cIndex>=this.cValue.length){
            this.cValue.push(val)
            this.cIndex=Number(this.cIndex)+1
          }else{
            this.value[this.cIndex]=val
            this.cIndex=Number(this.cValue.length)
            this.$emit('onChange', _.join(this.cValue, ''))
          }
          break
      }
    },
    input2 (val, index) {
      if(this.cValue.length < 6 || (this.type === 1 && index < 6) || this.type === 3) return
      this.cValue.push(val)
      this.cIndex=Number(this.cIndex)+1
    }
  },
  watch: {
    value () {
      this.cValue = this.value
    },
    cValue () {
      this.$emit('onChange', _.join(this.cValue, ''))
    },
  }
}
</script>

<style lang="scss">
#key-board {
  .clearfix:after {
    content: ".";
    display: block;
    font-size: 0;
    height: 0;
    clear: both;
    visibility: hidden;
  }
  ul {
    background-color: #ced3d9;
    text-align: center;
    padding: 4px 2px;
    font-size: 16px;
    li {
      list-style: none;
      :active {
        background-color: #b9c2cf;
        color: #ffffff;
      }

      &.disabled span {
        color: #DDDDDD;
        background-color: #fff;
      }

    }
    span {
      display: block;
      background-color: #fff;
      border-radius: 4px;
      box-shadow: 2px 2px 2px #888888;
      line-height: 42px;
      padding-top: 2px;
    }
  }
  .ul_pro {
    li {
      float: left;
      width: 11.11%;
      padding: 2px;
      box-sizing: border-box;
    }
  }
  .ul_keybord {
    li {
      float: left;
      width: 10%;
      padding: 2px;
      box-sizing: border-box;
      &.ikeycodeDel {
        width: 22%;
      }
    }
  }

  .ul_pro .li_close {
    float: right;
    width: 22.22%;
  }
  .ul_pro .li_clean {
    float: right;
    width: 22.22%;
  }
  .ul_keybord .li_w {
    width: 11.11%;
  }
  .ul_keybord .ikey20 {
    margin-left: 5%;
  }
  .ikeycodeOK {
    opacity: 0;
  }

}
</style>
